// Mock data for Agenda Mais Med Landing Page

export const heroData = {
  tagline: "AGENTE DE IA HUMANIZADO",
  title: "Atenda seus pacientes 24 horas por dia",
  subtitle: "Atendimento via WhatsApp 24 horas por dia que marca consultas, responde dúvidas, envia lembretes automáticos e cuidados pós-consulta.",
  pricePrefix: "A partir de",
  price: "R$ 350,00",
  priceSuffix: "/mês",
  ctaPrimary: "Quero automatizar meu atendimento",
  ctaSecondary: "Ver demonstração"
};

export const chatDemoMessages = [
  { type: "user", text: "Olá! Meu nome é Maria.\nGostaria de agendar uma consulta na quinta às 10:30.", time: "18:00" },
  { type: "bot", text: "Olá Maria, bom dia!\nTemos disponibilidade no horário desejado.\nPara confirmar sua consulta, por gentileza informe seu email.", time: "18:01" },
  { type: "user", text: "maria@gmail.com", time: "18:02" },
  { type: "bot", text: "Perfeito Maria!\nConsulta agendada na quinta às 10:30.\nTe envio um lembrete antes.\nTenha um ótimo dia!", time: "18:03" }
];

export const features = [
  {
    id: 1,
    icon: "MessageSquare",
    title: "Atendimento 24 horas",
    description: "Responde instantaneamente a qualquer horário, sem fila de espera. Seus pacientes sempre terão atendimento imediato.",
    details: [
      { label: "Disponibilidade", value: "24h por dia, 7 dias" },
      { label: "Tempo de resposta", value: "Menos de 30 segundos" }
    ],
    accent: "purple"
  },
  {
    id: 2,
    icon: "Calendar",
    title: "Agendamento Inteligente",
    description: "Agenda, remarca e cancela consultas automaticamente com sincronização em tempo real com sua agenda.",
    details: [
      { label: "Integração", value: "Google Calendar" },
      { label: "Automação", value: "Lembretes automáticos" }
    ],
    accent: "blue"
  },
  {
    id: 3,
    icon: "Bell",
    title: "Lembretes Automáticos",
    description: "Envia lembretes personalizados aos pacientes antes das consultas, reduzindo drasticamente as faltas.",
    details: [
      { label: "Redução de faltas", value: "Até 70%" },
      { label: "Personalização", value: "Mensagens customizadas" }
    ],
    accent: "teal"
  },
  {
    id: 4,
    icon: "Heart",
    title: "Cuidados Pós-Consulta",
    description: "Acompanhamento automático após as consultas, enviando orientações e verificando o bem-estar do paciente.",
    details: [
      { label: "Follow-up", value: "Automático" },
      { label: "Satisfação", value: "Pacientes mais engajados" }
    ],
    accent: "pink"
  },
  {
    id: 5,
    icon: "HelpCircle",
    title: "Esclarecimento de Dúvidas",
    description: "Responde às dúvidas mais comuns dos pacientes sobre procedimentos, preparos e orientações.",
    details: [
      { label: "Base de conhecimento", value: "Personalizável" },
      { label: "Precisão", value: "Respostas configuradas" }
    ],
    accent: "orange"
  },
  {
    id: 6,
    icon: "Users",
    title: "Múltiplos Atendimentos",
    description: "Atende dezenas de pacientes simultaneamente, sem perder a qualidade e personalização.",
    details: [
      { label: "Capacidade", value: "Ilimitada" },
      { label: "Resultado", value: "3x mais conversões" }
    ],
    accent: "green"
  }
];

export const stats = [
  { number: "150+", label: "Consultórios Ativos" },
  { number: "50k+", label: "Atendimentos Gerenciados" },
  { number: "R$ 2M+", label: "Em Consultas Agendadas" },
  { number: "24/7", label: "Disponibilidade" }
];

export const benefits = [
  {
    title: "Sem contratar funcionários",
    description: "Economize com salários, encargos e treinamento"
  },
  {
    title: "Zero fila de espera",
    description: "Pacientes atendidos instantaneamente"
  },
  {
    title: "Menos faltas",
    description: "Lembretes reduzem ausências em até 70%"
  },
  {
    title: "Mais tempo para você",
    description: "Foque no que importa: seus pacientes"
  }
];

export const faqs = [
  {
    question: "O agente de IA realmente funciona 24 horas?",
    answer: "Sim! O agente funciona 24 horas por dia, 7 dias por semana, inclusive finais de semana e feriados. Nunca precisa de pausas, férias ou descanso. Seus pacientes sempre terão uma resposta imediata."
  },
  {
    question: "Como funciona o agendamento inteligente?",
    answer: "O agente de IA gerencia toda a sua agenda automaticamente. Ele verifica horários disponíveis em tempo real, agenda consultas conforme a preferência do paciente, realiza reagendamentos e cancelamentos, tudo de forma natural via WhatsApp."
  },
  {
    question: "Como funciona o envio de lembretes?",
    answer: "O sistema envia lembretes automáticos personalizados antes das consultas, via WhatsApp. Você define quando e qual mensagem enviar. Isso reduz significativamente as faltas."
  },
  {
    question: "E os cuidados pós-consulta?",
    answer: "Após as consultas, o agente pode enviar automaticamente orientações, verificar como o paciente está se sentindo e agendar retornos quando necessário."
  },
  {
    question: "Quanto tempo leva para configurar?",
    answer: "A implementação é feita em etapas: análise da rotina do seu consultório, configuração personalizada, treinamento dos agentes com dados específicos do consultório, testes e go-live. Todo o processo leva aproximadamente 2 semanas."
  }
];

export const whatsappNumber = "5511981445461";
export const whatsappMessage = "Quero mais informações de como automatizar o atendimento do meu consultório.";

export const companyInfo = {
  name: "Agenda Mais Med",
  logo: "/logo-agendamaismed-dark.png",
  logoAvatar: "https://agendamaismed.preview.static.emergentagent.com/logo-agendamaismed.png",
  domain: "agendamaismed.com.br",
  tagline: "Automação inteligente para clínicas médicas"
};
